import React from 'react';

import {PhotoSwipe} from 'react-photoswipe';
import 'react-photoswipe/lib/photoswipe.css';

import styles from './Slider.scss';

export default class Slider extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            isOpen: false,
            slides: this.props.slides,
        }

        this.items = [
            // Add gallery images
            // eslint-disable-next-line
            this.state.slides.map((slide, index)=>{
                if(slide.title.length > 0){
                    return(
                        {
                            src:    slide.photo.url,
                            w:      slide.photo.dimensions.width,
                            h:      slide.photo.dimensions.height,
                            pid:    slide.title[0].text + index,
                            title:  '<h5>' + slide.title[0].text + '</h5><p>' + slide.caption[0].text + '</p>'
                        }
                    )
                }
            })
        ]
        this.options = {
            bgOpacity: .75,
            history: true,
            focus: false,
            loop: true,
            captionEl: true,
    
            closeEl:true,
            fullscreenEl: true,
            zoomEl: true,
            shareEl: false,
            counterEl: true,
            arrowEl: true,
    
            addCaptionHTMLFn: function(item, captionEl, isFake) {
                if(!item.title) {
                    captionEl.children[0].innerHTML = '';
                    return false;
                }
                captionEl.children[0].innerHTML = item.title;
                return true;
            },
    
            showAnimationDuration: 300,
            hideAnimationDuration: 300
        }
    }

    openSwiper(){
        this.setState({isOpen: true})
    }

    handleClose = () => {
        this.setState({isOpen: false})
    };

    addSwiperToModal(){
        const modal = document.getElementById('modal')
        const swiper = document.querySelector('.pswp')
        if(modal && swiper){
            modal.append(swiper)
        }
    }

    componentDidMount(){
        this.addSwiperToModal()
    }


    render(){
        if(this.state.slides[0].title.length > 0){
            console.log(this.state.slides)
            return(
                <React.Fragment>
                    <div className={styles.slider_action} onClick={this.openSwiper.bind(this)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path fill="none" d="M0 0h24v24H0V0z"></path>
                            <path d="M20 2H4v20h16V2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z"> </path>
                        </svg>
                        <span className={styles.slider_amount}>{this.state.slides? + this.state.slides.length : ''}</span>
                    </div>
                    <PhotoSwipe isOpen={this.state.isOpen} items={this.items[0]} options={this.options} onClose={this.handleClose}/>
                </React.Fragment>
            )
        } else {
            return null
        }
    }
}


// WEBPACK FOOTER //
// ./src/Components/Slider/Slider.js